module.exports = __webpack_public_path__ + "media/images/background-auth-3082ea5fe4263221eac6286da5040c50.png";